import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=2f545db7&scoped=true&"
import script from "./Local.vue?vue&type=script&lang=js&"
export * from "./Local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f545db7",
  null
  
)

export default component.exports